export const JOB_POSITION_OPTIONS = [
  'Accounting Staff / Accounting Officer',
  'Admin Manager',
  'Assistant Manager / Operations Manager',
  'Business Developer Manager',
  'Content Moderator',
  'Customer Service Representative',
  'Data Labeler',
  'Debt Collection Agent (Local)',
  'HR Specialist / HR Generalist',
  'IT Support',
  'Operations Supervisor',
  'Outbound Sales Agent',
  'Project Manager',
  'QA Specialist / Analist',
  'Recruiter',
  'Software Specialist',
  'Team Leader',
  'Trainer',
  'Executive Assistant / Executive Secretary',
  'Others'
];
